/**
 * Makes a media event text string
 * @param {Object} options
 * @param {String} options.type - the type of media
 * @param {String} options.status - the status of media
 * @returns {String} - Media Event
 */
const media = ({ type, status }) => {
  if (type) return `${type}-media`;
  if (status) return `media-${status}`;
};

module.exports = media;
